import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { VAM_SERVICE } from '@eggplant/api-hosts'
import type { GetAssetVersionsResponse } from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  suiteId: string
  children?: (data: GetAssetVersionsResponse) => ReactElement
}

const GetSuiteVersionsRequest = ({
  suiteId,
  children
}: Props) => {
  const url = `${VAM_SERVICE}/assets/${suiteId}/versions`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      url={url}
    />
  )
}

export default GetSuiteVersionsRequest
